"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  ALL: null,
  HOMEPAGE: null,
  ABOUT_US: null,
  CONTACT_US: null,
  TEAM_MEMBERS: null,
  TESTIMONIALS: null,
  RESOURCES: null,
  THANK_YOU: null,
  INVITATION: null,
  FAQ: null,
  EVENT: null,
  COMING_SOON: null,
  SINGLE_PRODUCT: null,
  MULTI_PRODUCT: null,
  PRICING: null,
  MAINTENANCE: null,
  HOLIDAY: null,
  SERVICES: null,
  CASE_STUDY: null,
  OFFER: null,
  NEWSLETTER: null,
  E_BOOK: null,
  PILLAR: null
});

exports.default = _default;
module.exports = exports.default;